import * as React from 'react';
import styled from 'styled-components';
import { spacing4x, spacing1x } from '../../styles/spacing.js';
import { SKIP_LINKS_DATA_TESTIDS } from './constants.js';
import { SkipLinkItem } from './SkipLinkItem.js';
import { jsx } from 'react/jsx-runtime';

var SKIP_LINKS_ID = "_mntl-skip-links";
var Container = styled.section.withConfig({
  displayName: "SkipLinks__Container",
  componentId: "sc-18jnn1f-0"
})(["&&{position:fixed;top:", ";left:", ";display:flex;flex-direction:column;border-radius:", ";background-color:white;border:1px solid ", ";z-index:", ";transform:translateX(-200%);transition:transform 0.2s ease-out;}&&:focus-within{transform:translateX(0);}"], spacing4x, spacing4x, spacing1x, function (_ref) {
  var theme = _ref.theme;
  return theme.neutralColors.silver;
}, function (_ref2) {
  var zIndex = _ref2.zIndex;
  return zIndex !== null && zIndex !== void 0 ? zIndex : 1;
});
var SkipLinks = function SkipLinks(_ref3) {
  var isAppendToBodyDisabled = _ref3.isAppendToBodyDisabled,
    items = _ref3.items,
    zIndex = _ref3.zIndex;
  var elementRef = React.useRef(null);
  var removeExistingSkipLinksElement = function removeExistingSkipLinksElement() {
    var existingSkipLinksElement = document.getElementById(SKIP_LINKS_ID);
    if (existingSkipLinksElement && existingSkipLinksElement.parentElement) {
      existingSkipLinksElement.parentElement.removeChild(existingSkipLinksElement);
    }
  };
  var appendToBody = function appendToBody() {
    var skipLinkWrapper = document.createElement("div");
    skipLinkWrapper.setAttribute("id", SKIP_LINKS_ID);
    skipLinkWrapper.appendChild(elementRef.current);
    document.body.insertBefore(skipLinkWrapper, document.body.firstChild);
  };
  React.useEffect(function () {
    removeExistingSkipLinksElement();
    if (!isAppendToBodyDisabled) {
      appendToBody();
    }
    return function () {
      removeExistingSkipLinksElement();
    };
  }, [isAppendToBodyDisabled]);
  return /*#__PURE__*/jsx(Container, {
    "data-testid": SKIP_LINKS_DATA_TESTIDS.container,
    ref: elementRef,
    role: "list",
    zIndex: zIndex,
    children: items.map(function (linkItem, i) {
      return /*#__PURE__*/jsx(SkipLinkItem, {
        label: linkItem.label,
        href: linkItem.href,
        onClick: linkItem.onClick
      }, i);
    })
  });
};
SkipLinks.displayName = "SkipLinks";

export { SkipLinks };
